export default "__VITE_ASSET__B3ohD$F9__"